const isLargeScreen = window.matchMedia("(min-width: 1025px)").matches;
const isSmallScreen = window.matchMedia("(max-width: 1024px)").matches;
const isXSmallScreen = window.matchMedia("(max-width: 649px)").matches;
const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);


jQuery(document).ready(function($) {
/* ====================== DISPLAY HEIGHT VARS ======================  */
function updateVH() {
  const vh = (window.visualViewport?.height || window.innerHeight) * 0.01;
  document.documentElement.style.setProperty('--vh', `${vh}px`);

  // Force GSAP to re-calculate pinned elements
  if (window.ScrollTrigger) {
    ScrollTrigger.refresh();
  }
}

function setStaticVH() {
  const staticVH = (window.visualViewport?.height || window.innerHeight) * 0.01;
  document.documentElement.style.setProperty('--staticvh', `${staticVH}px`);
}

const isIOSPortrait = /iPad|iPhone|iPod/.test(navigator.userAgent) && window.innerHeight > window.innerWidth;

if (isIOSPortrait) {
  updateVH();
  setStaticVH();

  if (window.visualViewport) {
    window.visualViewport.addEventListener('resize', updateVH);
  } else {
    window.addEventListener('resize', updateVH);
  }

  window.addEventListener('load', updateVH);
}


/* ====================== SMOOTH SCROLL HASH LINKS ======================  */
    $('a[href*="#"]').on('click', function(event) {
        var targetId = $(this).attr('href').split('#')[1]; // Get the ID from the href
        var targetElement = $('#' + targetId); // Select the target element

        if (targetElement.length) { // Check if the element exists
            event.preventDefault(); // Prevent default anchor link behavior

            $('html, body').animate({
                scrollTop: targetElement.offset().top
            }, 800, 'swing'); // Smooth scroll animation
        }
    });

/* ====================== ADD CLASS TO EMPTY P TAGS ======================  */
    document.querySelectorAll('p').forEach(p => {
      if (p.innerHTML.trim() === '&nbsp;') {
        p.classList.add('only-nbsp');
      }
    });

/* ====================== HEADER FUNCTIONS  ======================  */
  $('.header__nav-toggle').on('click', function (e) {
      e.preventDefault();
      $(this).parent().toggleClass('open');
      $('.header__navigation').addClass('visible');
      $('body').toggleClass('noscroll');
  });

  $(window).scroll(function(){
    var windowScroll = $(window).scrollTop();

    if (windowScroll > window.innerHeight) {
      $(".header").addClass('header--scroll');
    } else {
      $(".header").removeClass('header--scroll');
    }
  });

  /* ====================== ACCORDIONS  ======================  */
   $('.accordion__row__heading').on('click', function() {
      var $row = $(this).closest('.accordion__row');
      var $body = $row.find('.accordion__row__body');

      if ($row.hasClass('is-active')) {
        // Close current row
        $body.slideUp(200);
        $row.removeClass('is-active');
      } else {
        // Close any open rows
        $('.accordion__row.is-active .accordion__row__body').slideUp(200);
        $('.accordion__row').removeClass('is-active');

        // Open clicked row
        $body.slideDown(200);
        $row.addClass('is-active');
      }
  });

/* ====================== MAP MARKERS  ======================  */
  if ($('#map-svg').length) {
      const $modal = $('#marker-modal');
      const $title = $('#modal-title');
      const $text = $('#modal-text');
      const $image = $('#modal-image');

      $('.map__marker').on('mouseenter', function () {
        const title = $(this).data('title');
        const text = $(this).data('text');
        const image = $(this).data('image');

        $title.text(title);
        $text.text(text);
        if (image) {
          $image.attr('src', image).show();
        } else {
          $image.hide();
        }

        $modal.stop(true, true).fadeIn(300);
      }).on('mousemove', function (e) {
        $modal.css({
          left: e.clientX + 10 + 'px',
          top: e.clientY + 20 + 'px'
        });
      }).on('mouseleave', function () {
        $modal.stop(true, true).fadeOut(200);
      });

      // GLOW
      const $glow = $('#glow-cursor');
      const $map = $('#map-svg');

      $map.on('mouseenter', function () {
        $glow.css('opacity', 1);
      });

      $map.on('mousemove', function (e) {
        const offset = $(this).offset();
        const x = e.pageX - offset.left;
        const y = e.pageY - offset.top;

        $glow.css({
          left: x + 'px',
          top: y + 'px'
        });
      });

      $map.on('mouseleave', function () {
        $glow.css('opacity', 0);
      });
    }
});


jQuery(window).on('load', function() {
  (function($) {
    if ($('.marquee__group').length) {
      const baseSpeed = 50; // pixels per second

      $('.marquee__group').each(function() {
        const $group = $(this);
        const logoCount = $group.find('img').length;

        // Duplicate content for seamless scroll
        $group.append($group.html());

        // Adjust speed if fewer than 10 logos
        const speed = logoCount < 10 ? baseSpeed / 2 : baseSpeed;

        const totalWidth = $group[0].scrollWidth / 2; // half because it's duplicated
        const duration = totalWidth / speed;

        $group.css('animation', `scroll-x ${duration}s linear infinite`);
      });
    }
  })(jQuery);
});

